import { z } from "zod";

// t("CREATED")
// t("COMPLETED")
export const reminderSnapshotStatusEnum = z.enum(["CREATED", "COMPLETED"]);

export type ReminderSnapshotStatus = z.infer<typeof reminderSnapshotStatusEnum>;
